import React from 'react';
export function DiferencialHibrido() {
  return <section className="w-full overflow-hidden" data-id="element-135">
      <img src="https://cdn.magicpatterns.com/uploads/5bUqNrKjP8swBNkTAogW7f/06b877cb-4997-4806-bc41-28941a052bcc.webp" alt="Lo que empieza a ordenarse cuando tenés un sistema real" className="w-full h-auto block pt-[0px]" data-id="element-136" />
    </section>;
}